import React, { useEffect } from 'react';
import {
  Card,
  CardContent,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import DashboardLayout from '../../layouts/DashboardLayout';
import { fetchCorrectionHistoryPapes } from '../../actions/CorrectorAction';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

function CorrectorHistory() {
  const correctionhistoryPaper = useSelector(
    (state) => state.essayPaperRequest.correctionHistoryPapers
  );
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchCorrectionHistoryPapes());
  }, []);
  const { t, i18n } = useTranslation();

  const language = useSelector((state) => state.language).selectedLanguage;

  useEffect(() => {
    if (language) {
      i18n.changeLanguage(language);
    }
  }, [language]);
  return (
    <DashboardLayout>
      <Card>
        <CardContent style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12}>
              <h2
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}
              >
                {t('corrector_corrected_papers')}
              </h2>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>{t('start_date')}</TableCell>
                    <TableCell>{t('teacher_name')}</TableCell>
                    <TableCell>{t('subject')}</TableCell>
                    <TableCell>{t('subject_title')}</TableCell>
                    <TableCell>{t('corrector_status')}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {correctionhistoryPaper.length >= 1 &&
                    correctionhistoryPaper.map((papers, index) => (
                      <TableRow key={index}>
                        <TableCell>{new Date().toDateString()}</TableCell>
                        <TableCell>{papers.teacherName}</TableCell>
                        <TableCell>{papers.subject}</TableCell>
                        <TableCell>{papers.title}</TableCell>
                        <TableCell>{papers.correctorStatus}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}

export default CorrectorHistory;
